import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { FormControl } from "../..";
import { WControlProvider } from "../WControlProvider/WControlProvider";
export const WFormControl = props => {
  return /*#__PURE__*/React.createElement(WControlProvider, _extends({}, props, {
    expectedControl: FormControl
  }));
};